module.exports = __webpack_public_path__ + "static/media/alert_rieltor_gift_mob@2x.0dc4fe82.png";